import React from "react";

const CountdownProgress = ({ showWhen, initialTime, remainingTime, showMessage = true }) => {

    if(showWhen) {
        const progress = remainingTime > 0 ? ((initialTime - remainingTime) / initialTime) * 100 : 100;

        return (
            <>
                <div className="w-[350px] text-center">
                    {/* Progress Bar */}
                    <div className="relative h-4 w-full bg-[#DDE3EF] rounded-full">
                        <div
                            className={`h-full bg-[#8BBBDF] rounded-full`}
                            style={{
                                width: `${progress}%`,
                                transition: progress === 0 ? "none" : "width 1s linear", // Stop animation when timeLeft is 0
                            }}
                        ></div>
                    </div>
                </div>
                {showMessage &&
                    <p className="text-[#191C20] font-sans tracking-[0.25px] text-2xl font-light leading-8">
                        This code will expire in {remainingTime} seconds.
                    </p>
                }
            </>
    
        );
    }
    return null;
    
};

export default CountdownProgress;
